import http from '../utils/http';

export async function getVerifyCode(params) {
  const { account, captcha, flag } = params;
  return http.get('api/admin/user/getVerifyCode'.concat(`?account=${account}&captcha=${captcha}&flag=${flag}`));
}
export async function checkVerifyCode(params) {
  const { account, verifyCode } = params;
  return http.get('api/admin/user/checkVerificationCode'.concat(`?account=${account}&verifyCode=${verifyCode}`));
}

export async function updatePasswordPc(params) {
  return http.post('api/admin/user/updatePasswordPc', params);
}
export async function getPasswordConfig() {
  return http.get('api/admin/user/getSysPasswordConfig');
}

export async function getCodeImg() {
  return http.get('captcha/getCaptcha');
}
export async function passwordStatus() {
  return http.get('api/admin/user/getPasswordValidateConfig');
}




// WEBPACK FOOTER //
// ./src/services/password.js